import Login from './Login'

export default Login


// WEBPACK FOOTER //
// ./src/modules/LoginPage/Components/index.js